import Cookies from 'universal-cookie';

class CookieService {
  private static readonly NONCE_KEY:string = 'quiz_nonce';
  private static readonly QWID_KEY:string = 'qwid';
  private static readonly MAXAGE:number = 31556952;

  private static _nonce:string | null = null;
  private static _qwid:string | null = null;

  private static cookies = new Cookies();

  public static setNonce(quizNameSlug:string, nonce:string){
    const name = `${quizNameSlug}_${this.NONCE_KEY}`;
    this.cookies.set(`${quizNameSlug}_${this.NONCE_KEY}`, nonce);
    if ( window.parent ){
      window.parent.postMessage(JSON.stringify({
        'action': 'setCookie',
        'name': name,
        'value': nonce,
        'maxage': this.MAXAGE
      }), '*')
    }
    this._nonce = nonce;
  }

  public static setQwid(qwid:string){
    this.cookies.set(this.QWID_KEY, qwid);
    if ( window.parent ){
      window.parent.postMessage(JSON.stringify({
        'action': 'setCookie',
        'name': this.QWID_KEY,
        'value': qwid,
        'maxage': this.MAXAGE
      }), '*')
    }
    this._qwid = qwid;
  }

  public static getNonce(){
    return this._nonce;
  }
  public static getQwid(){
    return this._qwid;
  }

  public static removeQwid(){
    this.cookies.remove(this.QWID_KEY)
  }

  public static clearStorage(quizNameSlug:string){
    const cookieNames = [
      // `${quizNameSlug}_quiz_status`,
      // `${quizNameSlug}_quiz_leaderboard_url`,
      `${quizNameSlug}_quiz_nonce`,
      'qwid'
    ];
    for ( let name of cookieNames ) {
      this.cookies.remove(name, {
        path: '/',
      });
      if (window.parent) {
        window.parent.postMessage(JSON.stringify({
          'action': 'removeCookie',
          'name': name,
        }), '*');
      }
    }
  }
}

export default CookieService;